import { render, staticRenderFns } from "./AddCustomer.vue?vue&type=template&id=5ef58df0&scoped=true"
import script from "./AddCustomer.vue?vue&type=script&lang=ts"
export * from "./AddCustomer.vue?vue&type=script&lang=ts"
import style0 from "./AddCustomer.vue?vue&type=style&index=0&id=5ef58df0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef58df0",
  null
  
)

export default component.exports